import React from 'react';
import { object, shape, number, bool, arrayOf } from 'prop-types';
import { I18n, getContext } from '@fiverr-private/fiverr_context';
import GigCardCarouselWrapper from '../shared/GigCardCarouselWrapper';
import SafePureComponent from '../shared/SafePureComponent';
import { OTHER_GIGS_BY } from '../../utils/carousels';

const OTHER_GIGS_SOURCE = 'other_gigs_by';

const OtherGigsBy = ({
    isTouch,
    isLoggedIn,
    otherGigs,
    studioInfo,
    shouldFetchCarousel = true
}, {
    pathfinderWrapper,
    general
}) => {

    const formatBoxTitle = () => {
        const { isStudio } = general;
        const { pathParameters } = getContext();
        let sellerName = pathParameters.username;
        let sellerUrl = pathfinderWrapper.pathfinder('short_user', { id: sellerName });

        if (isStudio) {
            const { name, slug } = studioInfo;
            sellerUrl = pathfinderWrapper.pathfinder('studio_page', { slug });
            sellerName = name;
        }

        return (
            <I18n k="gig_page_perseus.recommended_gigs.more_services_by.title"
                parseMarkup={true}
                params={{ seller_url: sellerUrl, seller_name: sellerName }}/>
        );
    };

    const { gigIds } = otherGigs;

    if (!gigIds.length) {
        return null;
    }

    const ajaxUrl = pathfinderWrapper.pathfinder('gig_page_fetch_other_gigs_by', { gigIds });

    return (
        <GigCardCarouselWrapper boxTitle={formatBoxTitle()}
            boxClass="gigs-other-gigs-by"
            boxLocation="bottom"
            type={OTHER_GIGS_BY}
            url={ajaxUrl}
            carouselPosition={2}
            isLoggedIn={isLoggedIn}
            isTouch={isTouch}
            shouldFetchCarousel={shouldFetchCarousel}
            source={OTHER_GIGS_SOURCE}/>
    );
};

OtherGigsBy.propTypes = {
    isTouch: bool,
    isLoggedIn: bool,
    otherGigs: shape({
        gigIds: arrayOf(number)
    }),
    studioInfo: object,
    shouldFetchCarousel: bool
};

OtherGigsBy.contextTypes = {
    pathfinderWrapper: object,
    general: object
};

export { OtherGigsBy };
export default SafePureComponent(OtherGigsBy);
